module.exports = __webpack_public_path__ + "img/green-checkmark.990c89c6.png";